
import React, { useRef, useState } from "react";
import ContactForm from "./ContactForm";
// Import Swiper React components
function HomeContact() {
  

  return (
    <div className="App">
 
 {/* <!-- Contact Section Start --> */}
        <div class="section section-padding" style={{paddingBottom : 100}}>
            <div class="container">

                {/* <!-- Contact Wrapper Start --> */}
                <div class="contact-wrapper">
                    <div class="row justify-content-center">
                        <div class="col-lg-6">
                            {/* <!-- Contact Content Start --> */}
                            <div class="contact-content">

                                {/* <!-- Contact Title Start --> */}
                                <div class="contact-title">
                                    <h4 class="sub-title">Don’t worry!</h4>
                                    <h2 class="main-title">If you have any query? Contact with us.</h2>
                                </div>
                                {/* <!-- Contact Title End --> */}

                                {/* <!-- Contact Form Start --> */}
                               <ContactForm /> 
                                {/* <!-- Contact Form End --> */}

                            </div>
                            {/* <!-- Contact Content End --> */}
                        </div>
                        <div class="col-lg-6">
                            {/* <!-- Contact Information Start --> */}
                            <div class="contact-information">
                                <div class="information-wrapper">

                                    <img class="shape" src="/assets/images/shape/shape-11.png" alt="" />

                                    <div class="single-info">
                                        <h3 class="info-title">Phone:</h3>

                                        <p>(+91) 8447009334</p>
                                        <br/>
                                        {/* <p>(+91) 8447009334</p> */}

                                    </div>
                                    <div class="single-info">
                                        <h3 class="info-title">Email:</h3>

                                        <p>healthfitsquare@gmail.com</p>
                                        <br/>
                                        {/* <p>healthfitsquare@gmail.com</p> */}

                                    </div>

                                    <div class="single-info">
                                        <h3 class="info-title">Timings:</h3>

                                        <p>Weekdays : 10:00 AM - 7:00 PM</p>
                                        <p>Sunday : Closed</p>

                                    </div>

                                    {/* <div class="single-info">
                                        <h3 class="info-title">Address:</h3>

                                        <p>A/256, Khirni Phatak Road,<br/>
                                        Near Patanjali Store, Tara Nagar-A, <br/>
                                        Tara Nagar Jhotwara, <br/>
                                        Jaipur, Rajasthan 302012
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                            {/* <!-- Contact Information End --> */}
                        </div>

                        {/* <!-- Question & Answer End -->  */}
                        <div class="question-answer" style={{border : 0, marginTop : 30}}>

                            <div class="row" style={{justifyContent : 'center'}}>
                                <div class="col-xl-4">
                                    {/* <!-- Answer User List Start --> */}
                                    <div class="answer-user-list">

                                        {/* <!-- Single User Start --> */}
                                        <div class="single-user active">
                                            
                                            <div class="user-content"  style={{maxWidth : '100%', paddingBottom : 0}}>
                                                <h6 class="name">Jaipur Main Office</h6>
                                                <p style={{marginTop : 10, marginBottom : 5}}>A/256, Khirni Phatak Road,<br/>
                                        Near Patanjali Store, Tara Nagar-A, <br/>
                                        Tara Nagar Jhotwara, <br/>
                                        Jaipur, Rajasthan 302012</p>
                                        <h7 class="name">Phone : </h7><span style={{fontSize : 12, color : '#fff'}}>(+91) 8447009334</span>
                                            </div>
                                        </div>
                                        {/* <!-- Single User End --> */}
                                        </div>
                                        </div>

                                        


                                        <div class="col-xl-4">
                                    {/* <!-- Answer User List Start --> */}
                                    <div class="answer-user-list">

                                        {/* <!-- Single User Start --> */}
                                        <div class="single-user active">
                                            
                                            <div class="user-content"  style={{maxWidth : '100%', paddingBottom : 0}}>
                                                <h6 class="name">Gurgaon Office</h6>
                                                <p style={{marginTop : 10, marginBottom : 5}}>Floor, V- 29/22, First,<br/>
                                                near DLF Club, <br/>
                                        DLF Phase 3, Nathupur,  <br/>
                                        Gurugram, Haryana 122002</p>
                                        <h7 class="name">Phone : </h7><span style={{fontSize : 12, color : '#fff'}}>(+91) 8949979942</span>

                                            </div>
                                        </div>
                                        {/* <!-- Single User End --> */}
                                        </div>
                                        </div>
                                        </div>
                                        </div>


                    </div>
                </div>
                {/* <!-- Contact Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Contact Section End --> */}

    </div>
  );
}

export default HomeContact;
